
export const LOAD_CURRENT_HALL_EVENTS_SUCCESS = 'LOAD_CURRENT_HALL_EVENTS_SUCCESS';
export const LOAD_CURRENT_HALL_EVENTS_FAILURE = 'LOAD_CURRENT_HALL_EVENTS_FAILURE';
export const LOAD_CURRENT_HALL_EVENTS_LOADING = 'LOAD_CURRENT_HALL_EVENTS_LOADING';

export const LOAD_PAST_HALL_EVENTS_SUCCESS = 'LOAD_PAST_HALL_EVENTS_SUCCESS';
export const LOAD_PAST_HALL_EVENTS_FAILURE = 'LOAD_PAST_HALL_EVENTS_FAILURE';
export const LOAD_PAST_HALL_EVENTS_LOADING = 'LOAD_PAST_HALL_EVENTS_LOADING';
